import { render, staticRenderFns } from "./AllowanceTypeDropdown.vue?vue&type=template&id=9a01758a&"
import script from "./AllowanceTypeDropdown.vue?vue&type=script&lang=js&"
export * from "./AllowanceTypeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports